export const BASE_URL = "https://www.genauhub.com";

export type Locale = "pt" | "en";

export function localeToHtmlLang(locale: Locale): string {
  return locale === "pt" ? "pt-BR" : "en-US";
}

export function buildLocaleAlternates(locale: Locale, pathname: string) {
  return {
    canonical: `${BASE_URL}/${locale}${pathname}`,
    languages: {
      "pt-BR": `${BASE_URL}/pt${pathname}`,
      en: `${BASE_URL}/en${pathname}`,
    },
  };
}

export function normalizeCategorySlug(slug: unknown): string {
  const safeSlug = Array.isArray(slug) ? String(slug[0] ?? "") : String(slug ?? "");
  return safeSlug
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");
}

export function buildMetaDescription(value: string, maxLength = 160): string {
  const normalized = value.replace(/\s+/g, " ").trim();
  if (normalized.length <= maxLength) return normalized;

  const sliced = normalized.slice(0, maxLength + 1);
  const lastSpace = sliced.lastIndexOf(" ");
  const safeSlice = lastSpace > 90 ? sliced.slice(0, lastSpace) : normalized.slice(0, maxLength);
  return safeSlice.trimEnd();
}

